export function addUserData(user: any) {
  if (!user) return
  const subscriptionPlan = user.subscriptions?.length > 0 ? `${user.subscriptions[0].plan_name}` : null
  window.$chatwoot?.setUser(user.id, {
    email: user.email,
    name: `${user.first_name} ${user.last_name}`
  })
  window.$chatwoot?.setCustomAttributes({
    subscriptionPlan,
    userId: user.id
  })
}

declare global {
  interface Window {
    $chatwoot?: {
      setUser: (id: any, data: any) => void
      setCustomAttributes: (attrs: any) => void
      reset: () => void
    }
    chatwootSDK?: {
      run: (config: any) => void
    }
  }
}
